import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_100: FaireProductEntity = {
  token: "catalog_prod_prod-100",
  type: "product",
  name: "Ornament Set",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 93.29,
  msrpDollars: 233.23,
  sku: "CA0100",
  caseSize: 12,
  material: "Wood",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 9,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_games-puzzles"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
